<template>
  <div class="browser-wrapper">
    <div
      v-if="!hasDriveAccess"
      class="gc-no-access"
    >
      <v-icon class="gc-no-access-icon" size="48">mdi-lock-outline</v-icon>
      <h2>No access</h2>
      <p>You don’t have permission to browse any drives.</p>
    </div>
    <file-browser
      v-else
      storages="s3"
      storage="s3"
      :axiosConfig="{ baseURL, withCredentials: true }"
      :key="bucket"
      :endpoints="endpoints"
      path="/"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import FileBrowser from '../components/FileBrowser';

export default {
  name: 'CloudManager',
  components: {
    FileBrowser
  },
  computed: {
    ...mapState([
      'bucket'
    ]),
    ...mapGetters([
      'visibleBuckets'
    ]),
    hasDriveAccess() {
      return this.visibleBuckets.length > 0;
    },
    baseURL() {
      return process.env.VUE_APP_BACKEND_URL;
    },
    endpoints() {
      return {
        list: { url: `/storage/${this.bucket}/list?path={path}`, method: "get" },
        upload: { url: `/storage/${this.bucket}/upload?path={path}`, method: "post" },
        download: { url: `/storage/${this.bucket}/download?path={path}`, method: "get" },
        get: { url: `/storage/${this.bucket}/get?path={path}`, method: "get" },
        move: { url: `/storage/${this.bucket}/move`, method: "post" },
        mkdir: { url: `/storage/${this.bucket}/mkdir?path={path}`, method: "post" },
        delete: { url: `/storage/${this.bucket}/delete?path={path}`, method: "post" },
      };
    }
  }
}
</script>

<style lang="scss">
.browser-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;

  .v-toolbar__content > .v-menu {
    display: block;
  }
}

.gc-no-access {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 32px 24px;
}

.gc-no-access-icon {
  margin-bottom: 16px;
  color: #f5c347 !important;
}

.gc-no-access h2 {
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: 600;
  color: #f5c347;
}

.gc-no-access p {
  margin: 0;
  max-width: 360px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  line-height: 1.5;
}
</style>